module.exports = __webpack_public_path__ + "media/1.2f2acb3a.mp4";